import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function DokumentacijaZaLegalizacijuPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Koja je osnovna dokumentacija za legalizaciju?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Osnovno su potrebni podaci o vlasniku i objektu, katastarske oznake te stručna geodetska i arhitektonska dokumentacija.",
        },
      },
      {
        "@type": "Question",
        name: "Moram li imati svu dokumentaciju odmah?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Ne. Dovoljno je dostaviti početne informacije, a ostatak dokumentacije priprema se kroz postupak.",
        },
      },
    ],
  };

  return (
    <div data-testid="dokumentacija-za-legalizaciju-page">
      <Seo
        title="Dokumentacija za legalizaciju"
        description="Popis dokumentacije potrebne za legalizaciju objekta i objašnjenje što je potrebno pripremiti prije predaje zahtjeva."
        path="/dokumentacija-za-legalizaciju"
        jsonLd={jsonLd}
      />

      <section className="border-b border-hair">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-16 lg:pt-28 lg:pb-20">
          <div className="overline text-ink-soft">Priprema predmeta</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-bold text-ink mt-6">
            Dokumentacija za<br />
            <span className="text-ink/40">legalizaciju</span>
          </h1>
          <p className="text-ink-soft leading-relaxed max-w-3xl mt-8">
            Dobra priprema dokumentacije skraćuje postupak i smanjuje rizik od
            dodatnih dopuna. U nastavku je pregled najčešće potrebnih podataka i
            dokumenata.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        <article className="md:col-span-8 space-y-6 text-ink-soft leading-relaxed">
          <h2 className="font-display text-3xl text-ink">Najčešće potrebno</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>osobni i kontakt podaci vlasnika</li>
            <li>adresa i osnovni podaci o objektu</li>
            <li>katastarska općina i broj čestice</li>
            <li>snimka izvedenog stanja i pripadajući elaborati</li>
          </ul>
          <h2 className="font-display text-3xl text-ink">Ako vam nešto nedostaje</h2>
          <p>
            Dovoljno je poslati ono što trenutno imate. Nakon početnog pregleda
            vodimo vas korak po korak do potpune dokumentacije potrebne za predaju
            zahtjeva.
          </p>
        </article>

        <aside className="md:col-span-4 border border-hair p-6 bg-white h-fit">
          <div className="overline text-ink-soft">Pošaljite podatke</div>
          <p className="text-ink-soft mt-3 text-sm leading-relaxed">
            Na temelju osnovnih informacija dobivate listu dokumentacije za vaš
            konkretan predmet.
          </p>
          <Link
            to="/prijava"
            className="inline-flex items-center gap-2 mt-5 bg-ink text-white px-5 py-3 text-sm font-medium rounded-sm hover:bg-[#112240] transition-colors"
          >
            Pošalji upit
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
          </Link>
        </aside>
      </section>
    </div>
  );
}
